import type { ReactNode } from 'react';

export type StatusBadgeStatus =
  | 'owned'
  | 'locked'
  | 'demo'
  | 'editor'
  | 'admin'
  | 'current'
  | 'completed';

type StatusBadgeTone = 'primary' | 'accent' | 'muted' | 'success';

interface StatusBadgeProps {
  status?: StatusBadgeStatus;
  label?: ReactNode;
  tone?: StatusBadgeTone;
  icon?: ReactNode;
  size?: 'sm' | 'md';
  className?: string;
}

const STATUS_MAP: Record<StatusBadgeStatus, { label: string; tone: StatusBadgeTone }> = {
  owned: { label: 'Доступно', tone: 'accent' },
  locked: { label: 'Закрыт', tone: 'muted' },
  demo: { label: 'Демо', tone: 'primary' },
  editor: { label: 'Editor', tone: 'accent' },
  admin: { label: 'Admin', tone: 'primary' },
  current: { label: 'Сейчас', tone: 'primary' },
  completed: { label: 'Готово', tone: 'success' },
};

const TONE_CLASS: Record<StatusBadgeTone, string> = {
  primary: 'bg-[rgba(107,78,230,0.12)] text-[var(--primary)]',
  accent: 'bg-[rgba(232,93,42,0.14)] text-[var(--accent)]',
  muted: 'bg-[rgba(26,26,26,0.08)] text-[rgba(26,26,26,0.66)]',
  success: 'bg-[rgba(16,185,129,0.14)] text-emerald-600',
};

export function StatusBadge({
  status,
  label,
  tone,
  icon,
  size = 'sm',
  className = '',
}: StatusBadgeProps) {
  const resolved =
    status ? STATUS_MAP[status] : { label: String(label ?? ''), tone: tone ?? 'muted' };
  const resolvedLabel = label ?? resolved.label;
  const resolvedTone = tone ?? resolved.tone;

  return (
    <span
      className={[
        'inline-flex items-center gap-1 rounded-full font-semibold uppercase tracking-[0.08em]',
        size === 'sm'
          ? 'px-3 py-1 text-[10px]'
          : 'px-3.5 py-1.5 text-[11px] min-[430px]:px-4',
        TONE_CLASS[resolvedTone],
        className,
      ].join(' ')}
    >
      {icon}
      <span>{resolvedLabel}</span>
    </span>
  );
}
